import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Fade from 'react-reveal/Fade';
import Header from '../header.jsx'
import CompPositions from '../comp-positions.jsx';
import {Helmet} from 'react-helmet';
import ModalVideo from 'react-modal-video';

class ThisIsUs extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
  }

  openModal () {
    this.setState({isOpen: true})
  }

  componentDidMount () {

    var section = document.getElementById("section");

    function calcVH() {
      var vH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        section.setAttribute("style", "height:" + vH + "px;");
      }

    calcVH();

    window.scrollTo(0, 0)
    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";
  }

  goBack(event) {
    var myDiv = document.getElementById('scroll');
    scrollTo(document.body, myDiv.offsetTop, 100);
  }

  render() {
    return (
      <div className="single-page us" id="single-page">
        <Helmet>
          <title>This is us</title>
          <link rel="canonical" href={location.protocol + '//' + location.host} />
          <meta property="og:title" content="This is us" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={location.href} />
          <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
        </Helmet>
        <Fade duration={1200} delay={0}>
          <div className="content-wrapper background" id="section">
            <div className="section-content">

              <div className="icon-scroll"></div>

              <h1 className="section-subheading">This is us</h1>
              <div className="section-heading">We're a family that</div>
              <div className="section-heading">likes to challenge</div>
              <div className="section-heading">old ideas</div>
            </div>
          </div>
        </Fade>
        <div className="content-wrapper dark" id="scroll">
          <div className="section-wrapper">
            <div className="section-content">
              <h2>About Bethard</h2>
              <div className="section-heading">Bethard - the</div>
              <div className="section-heading">people company</div>
              <p className="bread">We’re a group of passionate individuals who share the vision of taking  online gaming to the next level. What makes Bethard unique is the people and how we as a group love to challenge just about everything; structures, rules, each other and especially our competitors.
              </p>
              <p className="bread">
                We make things happen and we solve tough issues, all at the same time as we enjoy ourselves and, more importantly, each other. We are open about what is happening at work and we want everyone to feel included. We believe this is the way to make people involved and make them give all their creativity to make Bethard successful.
              </p>
            </div>
          </div>
        </div>
        <div className="content-wrapper image">
          <img src="/img/people_first_.jpg" />
        </div>
        <div className="content-wrapper dark two">
          <div className="section-wrapper">
            <div className="section-content">
              <div className="article-heading-wrapper">
                <div className="article-heading">People</div>
                <div className="article-heading">First.</div>
                <div className="article-heading-white">Work</div>
                <div className="article-heading-white">First.</div>
              </div>
              <div className="article-text-wrapper">
                <p className="bread">
                  Our company is built on one thing – everyone’s equal value. As a result, everyone's work is equally important. We don’t care about a title or about traditional structures. We do use titles in our company, but most people really don’t care about them since it doesn’t matter how far up the hierarchy you are. At Bethard, people talk very openly and all doors are always open.</p>
                <p className="bread">
                  We are a bunch of committed people who love to challenge just about everything; structures, rules, each other and especially our competitors. Whenever we see an opportunity, we throw ourselves at it. It comes naturally to us; it is part of our DNA. To constantly dare to do takes courage, something that is provided to us by always supporting each other and stand united in both prosperity and adversity.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="content-wrapper dark three">
          <div className="section-wrapper">
            <div className="section-content">
              <div className="section-heading">Our vision is also</div>
              <div className="section-heading light">how we work</div>
            </div>
            <ul>
              <li className="first">
                <img src="/img/us_01_howwework.jpg" />
                <div className="bullet-content">
                  <h2>Hierarchy</h2>
                  <div className="heading">We believe in people. not titles</div>
                  <p>We don’t believe in the old authoritative style where everyone is sitting at their desk waiting for a task, being told what to do. We prefer when our co-workers are the ones solving the problems while our leaders give support and guidance if needed.</p>
                </div>
              </li>
              <li className="second">
                <img src="/img/us_02_howwework.jpg" />
                <div className="bullet-content">
                  <h2>We trust you</h2>
                  <div className="heading">Freedom and responsibility</div>
                  <p>Responsible people thrive on freedom. We give our people a framework so that they can use that freedom. Why? Because we know that this will give us the full creativity of our talented employees. And that creativity will give us amazing results as a company.</p>
                </div>
              </li>
              <li className="third">
                <img src="/img/us_04_howwework.jpg" />
                <div className="bullet-content">
                  <h2>Dare more</h2>
                  <div className="heading">Failure is a step closer to victory</div>
                  <p>To us FAIL means First Attempt In Learning. We choose to see our failures as progress. This business culture requires a lot of responsibility and great commitment from our staff. Everyone at Bethard knows what it takes to be a part of this game – losing to us is not an option.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="content-wrapper light one">
          <div className="section-content">
            <h2>Work and play</h2>
            <div className="section-heading">United in both</div>
            <div className="section-heading">work and play</div>
            <p>Great things start with great team spirit - We believe that sharing fun experiences in and outside the office are the foundations upon which a tight group are built on. It helps inspire creativity and leads to bolder business decisions.
              A tight group that shares fun experiences, helping inspire creativity and leading to bolder business decisions – a formula that that has worked very well for the brand and produces a unique team culture.</p>
          </div>
        </div>
        <div className="content-wrapper image">
          <img src="/img/us_04_playhard.jpg" />
        </div>
        <div className="content-wrapper image">
          <img src="/img/thisisus_teamjpg.jpg" />
        </div>
        <div className="content-wrapper light two">
          <div className="section-wrapper">
            <div className="section-content">
              <div className="article-heading-wrapper">
                <div className="article-heading">Work</div>
                <div className="article-heading">Hard.</div>
                <div className="article-heading">Play</div>
                <div className="article-heading">Harder.</div>
              </div>
              <div className="article-text-wrapper">
                <p className="bread">
                  Our values and vision sets our DNA and creates a great place to work with a foundation of respect, equality and dare to do spirit. Our goal is to hire people who believe what we believe.
                  </p>
                <br/>
                <p className="bread">Our benefits and time-off policies are some of the most generous and action packed in the game. Rightly so: Our team is in training all the time - constantly pushing and developing ourselves and the business.</p>
              </div>
            </div>
          </div>
        </div>

        <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='uXy7B8RXBmg' onClose={() => this.setState({isOpen: false})} />
        <div className="content-wrapper image margin">
          <img src="/img/milan-cover.jpg" />
          <a onClick={this.openModal} target="_blank"><img src="/img/video-button.png" className="video-button" /></a>
        </div>

        <CompPositions/>
      </div>
    );
  }
}

export default ThisIsUs;



// WEBPACK FOOTER //
// ./client/components/pages/this-is-us.jsx